

// import React, { useRef, useState } from "react";
// import "./ExpenseReport.css";
// import html2pdf from "html2pdf.js";

// export default function ExpensesReport() {
//   const [category, setCategory] = useState("");
//   const [period, setPeriod] = useState("Daily");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [reportData, setReportData] = useState([]);
//   const [showTable, setShowTable] = useState(false);

//   const reportRef = useRef();
//   const API = "https://bodhimaram.onrender.com/api/expenses/report";

//   const normalize = (val) =>
//     (val || "").toLowerCase().trim();

//   /* ===== GET REPORT ===== */
//   const handleGetReport = async () => {
//     setShowTable(false);
//     setReportData([]);

//     const query = `?fromDate=${fromDate}&toDate=${toDate}`;

//     const res = await fetch(API + query);
//     const data = await res.json();

//     let filtered = [];

//     if (category === "all") {
//       // ✅ SHOW ALL DATA
//       filtered = Array.isArray(data) ? data : [];
//     } else {
//       // ✅ FILTER SPECIFIC CATEGORY
//       filtered = Array.isArray(data)
//         ? data.filter(
//             (e) => normalize(e.category) === normalize(category)
//           )
//         : [];
//     }

//     setReportData(filtered);
//     setShowTable(true);
//   };

//   /* ===== TOTAL ===== */
//   const total = reportData.reduce(
//     (sum, e) => sum + Number(e.amount || 0),
//     0
//   );

//   /* ===== PDF ===== */
//   const handleDownloadPDF = () => {
//     if (!showTable || reportData.length === 0) {
//       alert("Please get report first");
//       return;
//     }

//     html2pdf()
//       .from(reportRef.current)
//       .set({
//         margin: 10,
//         filename: "Expense_Report.pdf",
//         html2canvas: { scale: 2 },
//         jsPDF: { orientation: "portrait", unit: "mm", format: "a4" },
//       })
//       .save();
//   };

//   return (
//     <div className="expense-report">
//       <h2>Expense Report</h2>

//       {/* FILTER BAR */}
//       <div className="report-filters">

//         {/* CATEGORY */}
//         <select
//           value={category}
//           onChange={(e) => setCategory(e.target.value)}
//         >
         
//           <option value="all">All Categories</option> {/* ✅ NEW */}
//           <option>Salary for teacher</option>
//           <option>Salary for Workers</option>
//           <option>Salary for cab</option>
//           <option>Celebration</option>
//           <option>Advance Payment</option>
//           <option>Expenses for Materials</option>
//           <option>Other</option>
//           <option>Miscellaneous</option>
//         </select>

//         {/* PERIOD */}
//         <select value={period} onChange={(e) => setPeriod(e.target.value)}>
//           <option>Daily</option>
//           <option>Weekly</option>
//           <option>Monthly</option>
//         </select>

//         {/* DATE RANGE */}
//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//         />

//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//         />

//         <button onClick={handleGetReport}>Get Report</button>

//         <button className="download" onClick={handleDownloadPDF}>
//           Download PDF
//         </button>
//       </div>

//       {/* TABLE */}
//       {showTable && (
//         <div ref={reportRef}>
//           <div style={{ marginBottom: "10px" }} className="strong">
//             <strong>Category:</strong>{" "}
//             {category === "all" ? "All Categories" : category} &nbsp; | &nbsp;
//             <strong>Period:</strong> {period} &nbsp; | &nbsp;
//             <strong>From:</strong> {fromDate || "-"} &nbsp; | &nbsp;
//             <strong>To:</strong> {toDate || "-"}
//           </div>

//           <table className="report-table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Category</th>
//                 <th>Description</th>
//                 <th>Amount (₹)</th>
//               </tr>
//             </thead>

//             <tbody>
//               {reportData.length === 0 ? (
//                 <tr>
//                   <td colSpan="4" className="empty">
//                     No records found
//                   </td>
//                 </tr>
//               ) : (
//                 reportData.map((e) => (
//                   <tr key={e.id}>
// <td>{new Date(e.date).toLocaleDateString('en-GB')}</td>   
//                  <td>{e.category}</td>
//                     <td>{e.description || "-"}</td>
//                     <td className="amount">
//                       ₹{Number(e.amount).toFixed(2)}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>

//             <tfoot>
//               <tr>
//                 <td colSpan="3" className="total-label">
//                   Total Expense
//                 </td>
//                 <td className="total-amount">
//                   ₹{total.toFixed(2)}
//                 </td>
//               </tr>
//             </tfoot>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }



import React, { useRef, useState } from "react";
import "./ExpenseReport.css";
import html2pdf from "html2pdf.js";

export default function ExpensesReport() {
  // const [category, setCategory] = useState("");

  const [category, setCategory] = useState("all");
  const [period, setPeriod] = useState("Daily");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportData, setReportData] = useState([]);
  const [showTable, setShowTable] = useState(false);

  // resposes
const [showCategory, setShowCategory] = useState(false);
const [showPeriod, setShowPeriod] = useState(false);

  const reportRef = useRef();
  const API = "https://bodhimaram.onrender.com/api/expenses/report";

  const normalize = (val) =>
    (val || "").toLowerCase().trim();




// const handleGetReport = () => {
//   const data = [
//     {
//       id: 1,
//       date: "2026-01-10",
//       category: "Salary for teacher",
//       description: "January Salary",
//       amount: 15000,
//     },
//     {
//       id: 2,
//       date: "2026-01-12",
//       category: "Celebration",
//       description: "Pongal Celebration",
//       amount: 5000,
//     },
//     {
//       id: 3,
//       date: "2026-01-15",
//       category: "Salary for Workers",
//       description: "Worker Salary",
//       amount: 8000,
//     },
//     {
//       id: 4,
//       date: "2026-01-20",
//       category: "Expenses for Materials",
//       description: "Books Purchase",
//       amount: 3500,
//     },
//     {
//       id: 5,
//       date: "2026-01-25",
//       category: "Advance Payment",
//       description: "Advance Given",
//       amount: 2000,
//     },
//   ];

//   let filtered = [];

//   if (category === "all") {
//     filtered = data;
//   } else {
//     filtered = data.filter(
//       (e) => normalize(e.category) === normalize(category)
//     );
//   }

//   console.log(filtered);

//   setReportData(filtered);
//   setShowTable(true);
// };


// const total = reportData.reduce(
//   (sum, e) => sum + Number(e.amount || 0),
//   0
// );

// const handleDownloadPDF = () => {
//   if (!showTable || reportData.length === 0) {
//     alert("Please get report first");
//     return;
//   }

//   html2pdf()
//     .from(reportRef.current)
//     .set({
//       margin: 10,
//       filename: "Expense_Report.pdf",
//       html2canvas: { scale: 2 },
//       jsPDF: {
//         orientation: "portrait",
//         unit: "mm",
//         format: "a4",
//       },
//     })
//     .save();
// };



  const handleGetReport = async () => {
    setShowTable(false);
    setReportData([]);

    const query = `?fromDate=${fromDate}&toDate=${toDate}`;

    const res = await fetch(API + query);
    const data = await res.json();

    let filtered = [];

    if (category === "all") {
      // ✅ SHOW ALL DATA
      filtered = Array.isArray(data) ? data : [];
    } else {
      // ✅ FILTER SPECIFIC CATEGORY
      filtered = Array.isArray(data)
        ? data.filter(
            (e) => normalize(e.category) === normalize(category)
          )
        : [];
    }

    setReportData(filtered);
    setShowTable(true);
  };

  /* ===== TOTAL ===== */
  const total = reportData.reduce(
    (sum, e) => sum + Number(e.amount || 0),
    0
  );

  /* ===== PDF ===== */
  const handleDownloadPDF = () => {
    if (!showTable || reportData.length === 0) {
      alert("Please get report first");
      return;
    }

    html2pdf()
      .from(reportRef.current)
      .set({
        margin: 10,
        filename: "Expense_Report.pdf",
        html2canvas: { scale: 2 },
        jsPDF: { orientation: "portrait", unit: "mm", format: "a4" },
      })
      .save();
  };

  return (
    <div className="expense-report">
      <h2>Expense Report</h2>

      {/* FILTER BAR */}
      <div className="report-filters">

      
<div className="desktop-category">
  <select
    value={category}
    onChange={(e) => setCategory(e.target.value)}
  >
    <option value="all">All Categories</option>
    <option>Salary for teacher</option>
    <option>Salary for Workers</option>
    <option>Salary for cab</option>
    <option>Celebration</option>
    <option>Advance Payment</option>
    <option>Expenses for Materials</option>
    <option>Other</option>
    <option>Miscellaneous</option>
  </select>
</div>

{/* Mobile */}
<div className="mobile-category-row">

  <label className="category-label">
    Category
  </label>

  <div className="mobile-select-wrapper">

    <div
      className="mobile-select"
      onClick={() => setShowCategory(!showCategory)}
    >
      <div className="mobile-icon">
        📂
      </div>

      <span className="selected-text">
        {category}
      </span>

      <span>▼</span>
    </div>

    {showCategory && (
      <div className="mobile-options">
        {[
          "all",
          "Salary for teacher",
          "Salary for Workers",
          "Salary for cab",
          "Celebration",
          "Advance Payment",
          "Expenses for Materials",
          "Other",
          "Miscellaneous",
        ].map((item) => (
          <div
            key={item}
            className="mobile-option"
            onClick={() => {
              setCategory(item);
              setShowCategory(false);
            }}
          >
            {item}
          </div>
        ))}
      </div>
    )}

  </div>

</div>

        {/* PERIOD */}
        <div className="desktop-category">
        <select value={period} onChange={(e) => setPeriod(e.target.value)}>
          <option>Daily</option>
          <option>Weekly</option>
          <option>Monthly</option>
        </select>
        </div>


        <div className="mobile-category-row">

  <label className="category-label">
    Period
  </label>

  <div className="mobile-select-wrapper">

    <div
      className="mobile-select"
      onClick={() => setShowPeriod(!showPeriod)}
    >
      <div className="mobile-icon period-icon">
        📅
      </div>

      <span className="selected-text">
        {period}
      </span>

      <span>▼</span>
    </div>

    {showPeriod && (
      <div className="mobile-options">

        <div
          className="mobile-option"
          onClick={() => {
            setPeriod("Daily");
            setShowPeriod(false);
          }}
        >
          Daily
        </div>

        <div
          className="mobile-option"
          onClick={() => {
            setPeriod("Weekly");
            setShowPeriod(false);
          }}
        >
          Weekly
        </div>

        <div
          className="mobile-option"
          onClick={() => {
            setPeriod("Monthly");
            setShowPeriod(false);
          }}
        >
          Monthly
        </div>

      </div>
    )}

  </div>

</div>

        {/* DATE RANGE */}
        <div className="desktop-category">
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
         </div>

         <div className="mobile-category-row">

  <label className="category-label">
    From Date
  </label>

  <div className="mobile-date-box">

    <div className="mobile-icon date-icon">
      📅
    </div>


   
    <input
      type="date"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
      className="mobile-date-input"
    />
   
   
  </div>

</div>




 <div className="desktop-category">
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
         </div>


<div className="mobile-category-row">
  <label className="category-label">To Date</label>

  <div className="mobile-date-box">
    <div className="mobile-icon date-icon">📅</div>

    <input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      className="mobile-date-input"
    />
  </div>
</div>





        {/* <button onClick={handleGetReport}>Get Report</button>

        <button className="download" onClick={handleDownloadPDF}>
          Download PDF
        </button> */}

        <div className="button-group">
  <button onClick={handleGetReport}>Get Report</button>

  <button className="download" onClick={handleDownloadPDF}>
    Download PDF
  </button>
</div>
      </div>

      {/* TABLE */}
      {showTable && (
        <div ref={reportRef}>
          {/* <div style={{ marginBottom: "10px" }} className="strong">
            <strong>Category:</strong>{" "}
            {category === "all" ? "All Categories" : category} &nbsp; | &nbsp;
            <strong>Period:</strong> {period} &nbsp; | &nbsp;
            <strong>From:</strong> {fromDate || "-"} &nbsp; | &nbsp;
            <strong>To:</strong> {toDate || "-"}
          </div> */}
        


        {/* <p>Records: {reportData.length}</p> */}



    {/* SUMMARY CARDS (ONLY WHEN TABLE SHOWS) */}
{showTable && (
  <div className="summary-cards">

   <div className="card">
  <div className="card-icon">₹</div>
  <h4>Total Expense</h4>
  <p>₹{total.toFixed(2)}</p>
</div>

<div className="card">
  <div className="card-icon">#</div>
  <h4>Total Entries</h4>
  <p>{reportData.length}</p>
</div>

<div className="card">
  <div className="card-icon">↑</div>
  <h4>Highest</h4>
  <p>
    ₹{Math.max(...reportData.map(e => Number(e.amount || 0))).toFixed(2)}
  </p>
</div>

<div className="card">
  <div className="card-icon">📅</div>
  <h4>Period</h4>
  <p>{period}</p>
</div>
  </div>
)}




<h3 className="Expese_head">Expese Details</h3>


          <table className="report-table">
            <thead>
              <tr>
                <th >Date</th>
                <th className="head_col">Category</th>
                <th className="head_col">Description</th>
                <th className="head_col">Amount(₹)</th>
              </tr>
            </thead>

            <tbody>
              {reportData.length === 0 ? (
                <tr>
                  <td colSpan="4" className="empty">
                    No records found
                  </td>
                </tr>
              ) : (
                reportData.map((e) => (
                  <tr key={e.id}>
<td>{new Date(e.date).toLocaleDateString('en-GB')}</td>   
                 <td>{e.category}</td>
                    <td>{e.description || "-"}</td>
                    <td className="amount">
                      ₹{Number(e.amount).toFixed(2)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>

            <tfoot colSpan="1" className="footer_lable">
              <tr>
                <td  className="total-label">
                  Total
                </td>
                <td colSpan="3" className="total-amount">
                  ₹{total.toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}